import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import useDecisionTreeContext, { DecisionTreeContext } from './DecisionTreeContext/useDecisionTreeContext';
import useDecisionTreeRunContext from './DecisionTreeRunContext/useDecisionTreeRunContext';

export const DecisionTreePreviewContext = React.createContext<boolean>(false);

export default function useDecisionTreePreviewContext() {
  return React.useContext(DecisionTreePreviewContext);
}

export function DecisionTreePreviewContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [preview] = useQueryParam('preview-dt', StringParam);
  const { start } = useDecisionTreeRunContext();

  const { toggleMounted, isMounted } = useDecisionTreeContext();

  React.useEffect(() => {
    if (preview) {
      start(preview, undefined, true);
    }
  }, [preview]);

  const override = React.useMemo(() => ({ isMounted: 'main' as 'main' | 'split', toggleMounted, setPreference() { } }), [isMounted]);

  if (preview) {
    return (
      <DecisionTreeContext.Provider value={override}>
        <DecisionTreePreviewContext.Provider value={!!preview}>
          {children}
        </DecisionTreePreviewContext.Provider>
      </DecisionTreeContext.Provider>
    );
  }

  return (
    <DecisionTreePreviewContext.Provider value={!!preview}>
      {children}
    </DecisionTreePreviewContext.Provider>
  );
}
